/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect, useRef } from "react";
//#endregion
//#region Styles
import {
    Container, 
    ContainerCustomSelect, 
    ContentCustomSelect, 
    ContainerSelectOption, 
    SelectText, 
    OptionsBlock
} from "./styles";
import { 
    HelperText, 
    RequiredAsterisk, 
    Row 
} from "components/styles";
//#endregion
//#region Icons
import ArrowIcon from "icons/ArrowIcon";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import useAdjustFieldPopup from "utils/hooks/useAdjustFieldPopup";
//#endregion

const CustomSelect = ({
    className, label, direction = "column", 
    value, onChange, 
    width = {
        container: "max-width",
        containerSelect: "100%"
    },
    containerMinWidth, minWidth,
    defaultOptionText = "Seleccione una opción", 
    helperText, optionsProps = [], errorText,
    disabled = false, error = false, required = false
}) => {
    const $containerRef = useRef();
    //#region States
    const [showOptions, setShowOptions] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        setShowOptions(false);
        if (!value || value < -1 || optionsProps.length === 0) return;
        const currentItem = optionsProps.find(item => item.value === value);
        setSelectedItem(currentItem);
    }, [value, optionsProps]);
    useEffect(() => {
        if (value) return;
        setSelectedItem(null);
    }, [value]);
    //#endregion
    useAdjustFieldPopup({
        $containerRef, showPopup: showOptions
    });
    //#region Functions
    const toggleShowOptions = () => {
        setShowOptions(prev => !prev);
    }
    //#endregion
    const getClassName = (withError = false) => {
        const classList = [];
        if (className)
            classList.push(className);
        if (withError && error) 
            classList.push("error");
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    return (
        <Container 
            ref={$containerRef}
            className={getClassName()}
            data-field="select"
            containerMinWidth={containerMinWidth}
            direction={direction}
            width={width?.container}>
            {label && 
            <Row width="max-content" gap="3px">
                <label>{label}</label>
                {(required && !disabled) && <RequiredAsterisk>*</RequiredAsterisk>}
            </Row>}
            <ContainerCustomSelect 
                className={getClassName()}
                tabIndex={1}
                width={width?.containerSelect}
                onBlur={() => setShowOptions(false)}>
                <ContentCustomSelect>
                    <SelectText 
                        className={getClassName(true)}
                        minWidth={minWidth}
                        onClick={toggleShowOptions}>
                        <span title={selectedItem?.description || selectedItem?.text}>
                            {selectedItem?.text || defaultOptionText}
                        </span>
                        <ArrowIcon/>
                        <OptionsBlock className={`options-block ${showOptions ? "show" : ""}`}>
                            {optionsProps.map((props, idx) => {
                                const currentValue = props.value;
                                return (
                                    <CustomSelectOption 
                                        key={idx} 
                                        text={props.text}
                                        description={props?.description}
                                        selected={value === currentValue}
                                        onClick={() => onChange(currentValue, props.text)}/>
                                );
                            })}
                        </OptionsBlock>
                    </SelectText>
                    {helperText && 
                    <HelperText>{helperText}</HelperText>}    
                </ContentCustomSelect>
                <ErrorMessage
                    error={error}
                    text={errorText}/>
            </ContainerCustomSelect>
        </Container>
    );
}

const CustomSelectOption = ({ 
    text,
    description, 
    onClick, 
    disabled = false, 
    selected
}) => {
    const classList = [];
    disabled && classList.push("disabled");
    selected && classList.push("selected");
    return (
        <ContainerSelectOption 
            className={classList.join(" ")}
            onClick={onClick}
            title={description || text}>
            {text}
        </ContainerSelectOption>
    );
}

export default CustomSelect;